import { useState, useRef, useCallback } from 'react';

const STORAGE_KEY = "todayLocation";

const readStorage = () => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY));
    } catch {
        return null;
    }
};

const writeStorage = (data) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

const useLocationList = () => {
    const [locationList, setLocationList] = useState(null);
    const selectedLocation = useRef(0);

    const load = useCallback(() => {
        let info = readStorage();
        if (info) {
            if (info.list) setLocationList(info.list);
            selectedLocation.current = info.selected || "";
        }
        return info;
    }, []);

    const addLocation = useCallback((item) => {
        let info = readStorage() || {};
        if (!info.list) info.list = [];
        info.list.push({
            type: "add",
            label: item.label,
            lat: item.lat,
            lot: item.lot,
            key: new Date().getTime()
        });
        writeStorage(info);
        setLocationList([...info.list]);
    }, []);

    const removeLocation = useCallback((idx) => {
        let info = readStorage();
        if (!info || !info.list) return { isReload: false };
        let isReload = selectedLocation.current === info.list[idx].key;
        info.selected = "";
        info.list.splice(idx, 1);
        writeStorage(info);
        setLocationList([...info.list]);
        return { isReload };
    }, []);

    const selectLocation = useCallback((key) => {
        selectedLocation.current = key;
        let info = readStorage() || {};
        info.selected = key;
        writeStorage(info);
    }, []);

    const getSelectedLocationData = useCallback(() => {
        let info = readStorage();
        if (info && info.list && info.selected) {
            return info.list.find(item => item.key === info.selected) || null;
        }
        return null;
    }, []);

    return {
        locationList, setLocationList,
        selectedLocation,
        load, addLocation, removeLocation, selectLocation, getSelectedLocationData
    };
};

export default useLocationList;
